'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { makeEventRelay } from '../../core/EventRelay';
import memoizeOne from 'react-utils/memoizeOne';
import UIModalDialog from '../UIModalDialog';
import UIFullScreen from '../UIFullScreen';
import getTransitionProps from './getTransitionProps';
import { SandboxContext } from '../../context/SandboxContext';
export default class AbstractModal extends Component {
  constructor(props) {
    super(props);
    this._closeStartRelay = makeEventRelay();
    this._openCompleteRelay = makeEventRelay();
    this._getTransitionProps = memoizeOne(getTransitionProps);
  }

  render() {
    const _this$props = this.props,
          {
      componentName,
      _contextual,
      ModalDialog,
      onOpenStart,
      onOpenComplete,
      onCloseStart,
      onCloseComplete,
      Transition,
      rootNode
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["componentName", "_contextual", "ModalDialog", "onOpenStart", "onOpenComplete", "onCloseStart", "onCloseComplete", "Transition", "rootNode"]);

    const sandboxed = _contextual || this.context.sandboxed;

    const renderedModalDialog = /*#__PURE__*/_jsx(ModalDialog, Object.assign({}, rest, {
      contextual: _contextual,
      _openCompleteRelay: sandboxed ? null : this._openCompleteRelay,
      _closeStartRelay: sandboxed ? null : this._closeStartRelay
    }));

    return sandboxed ? renderedModalDialog : /*#__PURE__*/_jsx(UIFullScreen, {
      "data-layer-for": componentName,
      rootNode: rootNode,
      Transition: Transition,
      transitionProps: this._getTransitionProps(onOpenStart, this._openCompleteRelay.getHandle(onOpenComplete), this._closeStartRelay.getHandle(onCloseStart), onCloseComplete),
      children: renderedModalDialog
    });
  }

}
AbstractModal.propTypes = {
  componentName: PropTypes.string.isRequired,
  _contextual: PropTypes.bool,
  ModalDialog: PropTypes.elementType.isRequired,
  onOpenStart: PropTypes.func,
  onOpenComplete: PropTypes.func,
  onCloseStart: PropTypes.func,
  onCloseComplete: PropTypes.func,
  rootNode: UIFullScreen.propTypes.rootNode,
  Transition: PropTypes.elementType
};
AbstractModal.contextType = SandboxContext;
AbstractModal.defaultProps = {
  ModalDialog: UIModalDialog
};
AbstractModal.displayName = 'AbstractModal';